import React from "react";
import "../CSS/SubProduct.css";
import image1 from "../Assets/Kitchen/Product_Main/POTHOLDER 1.jpg";
import image2 from "../Assets/Kitchen/Product_Main/POTHOLDER 2.jpg";
import image3 from "../Assets/Kitchen/Product_Main/POTHOLDER 3.jpg";
import image4 from "../Assets/Kitchen/Product_Main/POTHOLDER 4.jpg";

function Potholder() {
  window.scrollTo(0, 0);

  return (
    <div className="product-main">
      <div>
        <div className="sub-product-head">
          <h3>Potholder</h3>
        </div>
        <div className="sub-product-flex">
          <img src={image1} />
          <img src={image2} />
          <img src={image3} />
          <img src={image4} />
        </div>
      </div>
    </div>
  );
}
export default Potholder;
